import React, { useState } from 'react';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [users, setUsers] = useState(JSON.parse(localStorage.getItem('users')) || []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = users.find((u) => u.email === formData.email);
    if (user && user.password === formData.password) {
      alert('Login successful!');
    } else {
      alert('Invalid email or password.');
    }
  };

  const handleSignup = () => {
    const newUser = { email: formData.email, password: formData.password };
    setUsers([...users, newUser]);
    localStorage.setItem('users', JSON.stringify([...users, newUser]));
    alert('Account created! You can now log in.');
  };

  return (
    <div className="login-container">
      <h1 className="text-3xl font-bold text-center">Login</h1>
      <form className="login-form" onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          className="form-input"
          required
        />
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Password"
          className="form-input"
          required
        />
        <button type="submit" className="login-btn">Log In</button>
        <button type="button" onClick={handleSignup} className="login-btn">Sign Up</button>
      </form>
      <a href="/forgot-password" className="forgot-password">Forgot Password?</a>
    </div>
  );
};

export default Login;